<template>
  <div class="banner">
    <div class="item">
      <img :src=dataList[currentIndex]>
    </div>
    <div class="page" v-if="this.dataList.length > 1">
      <ul>
        <li @click="gotoPage(prevIndex)">&lt;</li>
        <li v-for="(item,index) in dataList" @click="gotoPage(index)" :class="{'current':currentIndex === index}">
          {{ index + 1 }}
        </li>
        <li @click="gotoPage(nextIndex)">&gt;</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rotation",
  data() {
    return {
      dataList: [
        require('../assets/img/img_01.webp'),
        require('../assets/img/img_02.webp'),
        require('../assets/img/img_03.webp'),
        require('../assets/img/img_04.webp')
      ],
      currentIndex: 0,   //默认显示图片
    }
  },
  methods: {
    gotoPage(index) {
      this.currentIndex = index;
    },
    //定时器
    runInv() {
      setInterval(() => {
        this.gotoPage(this.nextIndex)
      }, 2000)
    }
  },

  mounted() {
    this.runInv()
  },

  computed: {
    //上一张
    prevIndex() {
      if (this.currentIndex === 0) {
        return this.dataList.length - 1;
      } else {
        return this.currentIndex - 1;
      }
    },
    //下一张
    nextIndex() {
      if (this.currentIndex === this.dataList.length - 1) {
        return 0;
      } else {
        return this.currentIndex + 1;
      }
    }
  },
}
</script>

<style scoped>
img {
  border-radius: 3px;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 50%);
}

* {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
  float: left;
  width: 30px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  color: rgba(245, 222, 179, 0.8);
  font-size: 14px;
  transition: color 0.3s ease;
}

ul li:hover {
  color: #FFD700;
}

.banner {
  width: 100%;
  position: relative;
  height: 100%;
  min-height: 350px;
  aspect-ratio: 16/9;
  overflow: hidden;
}

.banner img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  object-position: center;
}

.banner .page {
  background: rgba(0, 0, 0, .5);
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
}

.banner .page ul {
  float: right;
}

.current {
  color: #DC143C;
  font-weight: bold;
}

</style>
